import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const UnorderedListIcon = createSvgIcon(
  <>
    <path d="M1.46892 5.6C0.656117 5.6 0 6.22533 0 7C0 7.77467 0.656117 8.4 1.46892 8.4C2.28172 8.4 2.93784 7.77467 2.93784 7C2.93784 6.22533 2.28172 5.6 1.46892 5.6ZM1.46892 0C0.656117 0 0 0.625333 0 1.4C0 2.17467 0.656117 2.8 1.46892 2.8C2.28172 2.8 2.93784 2.17467 2.93784 1.4C2.93784 0.625333 2.28172 0 1.46892 0ZM1.46892 11.2C0.656117 11.2 0 11.8347 0 12.6C0 13.3653 0.66591 14 1.46892 14C2.27193 14 2.93784 13.3653 2.93784 12.6C2.93784 11.8347 2.28172 11.2 1.46892 11.2ZM4.40676 13.5333H18.1167V11.6667H4.40676V13.5333ZM4.40676 7.93333H18.1167V6.06667H4.40676V7.93333ZM4.40676 0.466667V2.33333H18.1167V0.466667H4.40676Z" />
  </>,
  "UnorderedListIcon"
);

export default UnorderedListIcon;
